export default {
  mail_status: {
    see_message: "Nachricht ansehen",
    see_incident: "Vorfall ansehen",
    not_filled: "Nicht verfügbar",
    field_label: "Postfachstatus",
    status: {
      valid: "Gültig",
      valid_with_incident: "Vorfall gemeldet",
      temporary_block: "Temporäre Sperre",
      definitive_block: "Endgültige Sperre",
    },
    category: {
      reputation: "Absenderreputation",
      unknown_recipient: "Unbekannter Empfänger",
      other: "Sonstiges",
    },
    reputation: {
      platform_alert:
        "Auf Ihrer Plattform wurde ein Reputationsproblem festgestellt, das die Zustellbarkeit von E-Mails beeinträchtigt. Das technische Team wurde alarmiert und arbeitet aktiv an der Behebung.",
    },
    code: {
      invalid_email_format: "Ungültiges E-Mail-Format",
      transport_error: "Übertragungsfehler",
      send_error: "Sendefehler",
    },
    send_dot: {
      pending: "Die E-Mail wird vorbereitet, sie wurde noch nicht versendet.",
      sent: "Die E-Mail wurde erfolgreich versendet",
      incident: "Die E-Mail wurde versendet, aber der Empfängerserver hat sie blockiert",
      blocked: "Die E-Mail wurde wegen eines Problems mit der Empfängeradresse nicht versendet",
      error: "Die E-Mail konnte aufgrund eines technischen Fehlers beim Senden nicht versendet werden",
      unknown: "Der Sendestatus dieser E-Mail wird nicht erkannt",
    },
    modal: {
      title: "Gesperrte E-Mail",
      title_incident: "Vorfall bei der Adresse gemeldet",
      title_valid: "Status des Postfachs",
      blocked_at: "Gesperrt am",
      cause: "Ursache",
      no_cause: "Keine Rückmeldung des Servers",
      unblock: "Jetzt entsperren",
      unblock_error: "Die Sperre konnte nicht aufgehoben werden, bitte versuchen Sie es erneut.",
      unblock_success: "Sperre aufgehoben — die Adresse gilt wieder als gültig.",
      hint_blocked: "Korrigieren Sie die Adresse bei Bedarf und entsperren Sie sie manuell.",
      hint_incident:
        "Ein Vorfall wurde erkannt, hat aber die Sperrschwelle nicht erreicht — keine Aktion erforderlich.",
      hint_valid: "Diese Adresse funktioniert normal, keine Aktion erforderlich.",
    },
  },
};
